
// 🚨 LEGACY MODULE - DEPRECATED FOR NEW ONBOARDING
// This module is preserved only for reroll and upgrade functionality
// New BroCode generation should use the complete-initiation edge function

// 🚨 LEGACY: Generate a random 4-character suffix (used only for rerolls)
const generateRandomSuffix = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 4; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// 🚨 LEGACY: Generate BroCode with custom prefix (used only for rerolls/upgrades)
export const generateBroCode = (prefix?: string, walletAddress?: string): string => {
  console.warn('⚠️ LEGACY: generateBroCode used - new onboarding should use complete-initiation edge function');
  
  let chosenPrefix: string;
  
  if (prefix) {
    // Use provided prefix for special cases (like rerolls)
    chosenPrefix = prefix;
  } else {
    // For legacy compatibility, use a simple prefix
    const legacyPrefixes = ['ALPHA', 'BETA', 'GAMMA', 'DELTA', 'SIGMA'];
    chosenPrefix = legacyPrefixes[Math.floor(Math.random() * legacyPrefixes.length)]!;
  }
  
  // If wallet address is provided, use last 4 characters, otherwise generate random
  const suffix = walletAddress 
    ? walletAddress.slice(-4).toUpperCase()
    : generateRandomSuffix();
  
  return `${chosenPrefix}-${suffix}`;
};

// 🚨 LEGACY: Function for backward compatibility (used only for existing integrations)
export const generateInitialBroCode = (walletAddress: string): string => {
  console.warn('⚠️ LEGACY: generateInitialBroCode used - new onboarding should use complete-initiation edge function');
  return generateBroCode(undefined, walletAddress);
};

// 🚨 LEGACY: Specific function for generating BROMETHEUS codes (used only for upgrades)
export const generateBrometheusBroCode = (walletAddress: string): string => {
  console.warn('⚠️ LEGACY: generateBrometheusBroCode used - should only be used for manual upgrades');
  return `BROMETHEUS-${walletAddress.slice(-4).toUpperCase()}`;
};
